import { shipsButtonId } from "constants/portalIds";
import { getDocumentGroupHeaderPathFunc } from "lib/routeUtils";
import { LAST_SHIP_KEY, SHIPS_PATH } from "./shipsConsts";
import { Cat } from "components/Common/Icons/Cat";

export const shipRouteAppHeaderConfig = {
  path: SHIPS_PATH,
  staticData: {
    label: "Picotitan",
    icon: ({ hovered }) => <Cat hovered={hovered} />,
    buttonId: shipsButtonId,
    requiresGroup: true,
    getHeaderPath: getDocumentGroupHeaderPathFunc({
      localStorageKey: LAST_SHIP_KEY,
      path: SHIPS_PATH,
    }),
  },
};
